<template>
    <div>
        <Header title="测评密码" memo="管理和发布测评密码信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }">
                    生成密码
                </a-button>
                <a-button icon="copy" @click="doCopyUrl" :style="{ marginRight: '8px' }">
                    测评地址
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="用户名称" @pressEnter="execQuery"
                                 :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.mob" placeholder="用户手机" @pressEnter="execQuery"
                                 :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading"
                 :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column key="name" ellipsis width="130px">
                <span slot="title">测评密码</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.code }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="tuser" ellipsis>
                <span slot="title">测评用户</span>
                <template slot-scope="text, record">
                    <a-popover placement="top" v-if="record.testing.id">
                        <template slot="content">
                            <p>
                                分组：
                                <span>{{ record.org }}</span>
                            </p>
                            <p>
                                姓名：
                                <span>{{ record.tuser.name }}</span>
                            </p>
                            <p>
                                手机号：
                                <span>{{ record.tuser.mobile }}</span>
                            </p>
                            <p>
                                性别：
                                <span>{{ record.tuser.gender === 'M' ? '男' : '女' }}</span>
                            </p>
                            <p>
                                年龄：
                                <span>{{ record.tuser.age }}</span>
                            </p>
                            <p>
                                激活时间：
                                <span>{{ record.active }}</span>
                            </p>
                            <p>
                                过期时间：
                                <span>{{ record.expire }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评人信息</span>
                        </template>
                        <template>{{ record.tuser.name }} [{{ record.tuser.mobile }}]</template>
                    </a-popover>
                    <a-tag color="#2db7f5" v-else>暂未激活</a-tag>
                </template>
            </a-table-column>
            <a-table-column key="testing" ellipsis>
                <span slot="title">当前测评</span>
                <template slot-scope="text, record">
                    <a-popover placement="top" v-if="record.testing.id">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.testing.id }}</span>
                            </p>
                            <p>
                                状态：
                                <span>{{ record.testing.state | testingState }}</span>
                            </p>
                            <p>
                                进度：
                                <span>{{ record.testing.step }}</span>
                            </p>
                            <p>
                                得分：
                                <span>{{ record.testing.score }}</span>
                            </p>
                            <p>
                                评级：
                                <span>{{ record.testing.level }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评信息</span>
                        </template>
                        <template>[ {{ record.testing.state | testingState }} ] {{ record.testing.step }}</template>
                    </a-popover>
                    <a-tag color="#2db7f5" v-else>暂无测评</a-tag>
                </template>
            </a-table-column>

        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />
        <a-modal v-model="visible" title="测评地址" @ok="() => (this.visible = false)">
            <p>密码测评入口地址</p>
            <p>https://watermelon2.xinliyun.com?unid={{ unitId }}</p>
        </a-modal>
        <FormComp title="编辑用户分组" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>
    </div>
</template>

<script>
import FormComp from './FormComp'

export default {
    name: 'AteTestingCode',
    components: {
        FormComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        },
        unitId() {
            return this.$store.state.User.info.unit.id
        }
    },
    data() {
        return {
            visible: false,
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                name: '',
                mob: '',
                code: '',
                state: 'All'
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            reset: false,
            form: false,
            now: {}
        }
    },
    filters: {
        testingState: value => {
            switch (value) {
                case 'Wait':
                    return '未开始'
                case 'Run':
                    return '进行中'
                case 'Pause':
                    return '暂停中'
                case 'Finish':
                    return '已完成'
                case 'Abort':
                    return '已中止'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评密码'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            console.log(this.$store.state.User.info)
            this.$http
                .get('/cts/ate/testing/code/mgr/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/cts/ate/tester/org/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doCopyUrl() {
            this.visible = true
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                name: '',
                mob: '',
                code: '',
                state: 'All'
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}
            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },

        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的组织')
                return
            }
            this.$confirm({
                title: '是否删除以下组织？删除后无法恢复。',
                content: '组织：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        }
    }
}
</script>
